import {useAtom} from 'jotai';
import {zoomLevelAtom} from '@/map/atom';
import {palette} from '@/styles';
import {ToolboxItemProps} from './';
import {ReactComponent as ZoomInIcon} from './assets/zoom-in.svg';
import {ReactComponent as ZoomOutIcon} from './assets/zoom-out.svg';
import {ToolboxItem} from './StyledComponents';

export const ZoomController = (props: ToolboxItemProps) => {
  const [, setZoom] = useAtom(zoomLevelAtom);

  const changeZoomLevel = (next: 1 | -1) => {
    setZoom((prev) => prev + next);
  };

  return (
    <>
      <ToolboxItem className="hover" onClick={() => changeZoomLevel(1)}>
        <ZoomInIcon color={palette.gray800} />
      </ToolboxItem>
      <ToolboxItem
        {...props}
        className="hover"
        onClick={() => changeZoomLevel(-1)}
      >
        <ZoomOutIcon color={palette.gray800} />
      </ToolboxItem>
    </>
  );
};
